import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ArchivoMuyGrande = props => /*{{{*/ ( 
    <Dialog open={props.open} onClose={props.onClose} fullWidth maxWidth="xs"> 
        <DialogTitle>
            El archivo no pudo ser procesado
        </DialogTitle>
        <DialogContent>
            <Grid container>
                <Grid item xs={12}>
                    <Alert severity="warning">
            El archivo PDF cargado es válido, pero excede el tamaño máximo para este requisito ({props.maximaMedidaMb} Mb), intente subir un archivo de menor tamaño o use un compresor de archivos PDF. A continuación se presentan algunas opciones conocidas:
                    </Alert>
                    <List>
                        <ListItem>
                            <ListItemButton component="a" target="compressor" href="https://www.adobe.com/acrobat/online/compress-pdf.html">
                                <ListItemIcon>
                                    <img src="https://adobe.com/favicon.ico" style={{width: '1.5em', height: '1.5em'}}/>
                                    {/*<OpenInNewIcon color="secondary"/>*/}
                                </ListItemIcon>
                                <ListItemText primary="Adobe PDF compressor"/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component="a" target="compressor" href="https://www.ilovepdf.com/compress_pdf">
                                <ListItemIcon>
                                    <img src="https://ilovepdf.com/favicon.ico" style={{width: '1.5em', height: '1.5em'}}/>
                                    {/*<OpenInNewIcon color="secondary"/>*/}
                                </ListItemIcon>
                                <ListItemText primary="I Love PDF"/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem>
                            <ListItemButton component="a" target="compressor" href="https://pdfcompressor.com/">
                                <ListItemIcon><OpenInNewIcon color="secondary"/></ListItemIcon>
                                <ListItemText primary="PDF compressor"/>
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button type="button" variant="contained" onClick={props.onClose}>Cerrar</Button>
        </DialogActions>
    </Dialog>
    ) //}}}

export default ArchivoMuyGrande;
